"use client"
import { styled } from "styled-components"
import { black, darkBlueBackground, lighterGrey, white, accentYellow as yellow } from '../components/colors';

const StyledButton = styled.button<{
  $disabled?: boolean
  $secondary?: boolean
  $tertiary?: boolean
  $large?: boolean
  $hideBorder?: boolean
}>`
  background-color: ${({ $secondary, $tertiary }) => ($secondary ? lighterGrey : $tertiary ? darkBlueBackground : yellow)};
  font-size: ${props => (props.$large ? 24 : 15)}px;
  text-transform: uppercase;
  font-family: inherit;
  font-weight: bold;
  padding: 8px 16px;
  border-radius: 8px;
  color: ${({ $disabled, $secondary, $tertiary }) =>
          ($disabled && $secondary) || $tertiary ? white : black};
  border-width: ${({ $tertiary, $hideBorder }) => $hideBorder ? 0 : $tertiary ? '2px' : '2px'};
  border-style: solid;
  border-color: ${({ $tertiary }) => $tertiary ? 'white' : 'transparent'};
  cursor: ${({ $disabled }) => ($disabled ? "default" : "pointer")};
  opacity: ${({ $disabled }) => ($disabled ? 0.35 : 1)};
  margin: 10px 0px;

  &:active {
    transform: scale(${props => (props.$disabled ? 1 : 0.8)});
    transition: transform 0.2s ease-in-out;
  }
`

export const Button: React.FC<{
  disabled?: boolean
  secondary?: boolean
  tertiary?: boolean
  hideBorder?: boolean
  onClick: (e?: any) => void
  children: React.ReactNode
  type?: string
  large?: boolean
  style?: React.CSSProperties
}> = ({
  large = false,
  disabled = false,
  secondary = false,
  hideBorder,
  tertiary,
  children,
  onClick,
  style
}) => {
  return (
    <StyledButton
      onClick={(e) => !disabled && onClick(e)}
      $disabled={disabled}
      $secondary={secondary}
      $tertiary={tertiary}
      $large={large}
      $hideBorder={hideBorder}
      style={style}
    >
      {children}
    </StyledButton>
  )
}
